import { useDispatch, useSelector } from 'react-redux';
import FadeIn from 'react-fade-in';

import cx from 'classnames';

export default function InputRadioGrid(props){
	const {
		type,
		choices,
		index,
	} = props;
	const selection = useSelector( s => s.questions[index].selection )
	const dispatch = useDispatch();
	const rootId = useSelector( s => s.rootId );
	return <FadeIn className="checkbox-grid-choices" wrapperTag="ul"
		childClassName="checkbox-grid-choice" childTag="li"
		delay="30"
		transitionDuration="600" >
		{ choices.map( (c,choice_index) => {
			const choiceId = `${ rootId }-question-${ index }-choice-${ choice_index }`;
			return <div className="checkbox-grid-choice-inner" key={ `${ index }-${ choice_index }` } >
				<input
					checked={ selection === (choice_index) }
					type="radio"
					id={ choiceId }
					name={ `${ rootId }-question-${ index }` }
					value={ c.value }
					onChange={ e => {
						if ( e.target.checked ){
							dispatch({
								type: 'set/questionSelection',
								payload: {
									question: index,
									selection: choice_index
								}
							})
						}
					}}
				/>
				<label htmlFor={ choiceId } >
					<span className="text" dangerouslySetInnerHTML={{ __html: c.text }} /> 
				</label>
			</div>
		} ) }
	</FadeIn>
}
